// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

//import { LogLevel } from "angular-auth-oidc-client";
declare const require: any;

export const environment = {
  production: false,
  version: require("../../package.json").version,
  identityConfig: {
    redirectUrl: `${window.location.origin}`,
    postLogoutRedirectUri: `${window.location.origin}`,
    useRefreshToken: true,
    renewTimeBeforeTokenExpiresInSeconds: 60,
    silentRenew: true,
    silentRenewUrl: `${window.location.origin}/silent-renew.html`,
    autoUserInfo: true,
    //logLevel: LogLevel.Warn,
  },
  odataRoutePrefix: "odataWebClient",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
